import { IBeaconReportConfig } from '@/types/index';

const config: IBeaconReportConfig = {
  pageID: '30001003',
  eventTags: {
    // 曝光上报
    user_exposure: {
      'cameratoo.bar.exposure': {
        position: 'cameratoo.bar',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'open.exposure': {
        position: 'open',
        action_object: '1',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.cameratoo.exposure': {
        position: 'video.cameratoo',
        action_object: '1',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.share.exposure': {
        position: 'video.share',
        action_object: '1',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.exposure': {
        position: 'video',
        action_object: '1',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'hot.video.play.exposure': {
        position: 'hot.video.play',
        action_object: '1',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'more.video.exposure': {
        position: 'more.video',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.fold.exposure': {
        position: 'video.fold',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.like.exposure': {
        position: 'video.like',
        action_object: '1',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.headpic.exposure': {
        position: 'video.headpic',
        action_object: '2',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.headpic.focus.exposure': {
        position: 'video.headpic.focus',
        action_object: '2',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.topic.exposure': {
        position: 'video.topic',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.music.exposure': {
        position: 'video.music',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.location.exposure': {
        position: 'video.location',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'friendsfloat.open.exposure': {
        position: 'friendsfloat.open',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'recommend.video.exposure': {
        position: 'recommend.video',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'recommend.open.exposure': {
        position: 'recommend.open',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'recommend.again.exposure': {
        position: 'recommend.again',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'jump.weishi.exposure': {
        position: 'jump.weishi',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'last.float.btn.exposure': {
        position: 'last.float.btn',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'collection.back.exposure': {
        position: 'collection.back',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'collection.fold.exposure': {
        position: 'collection.fold',
        action_object: '',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.businesscard.shopping.short.exposure': {
        position: 'video.businesscard.shopping.short',
        action_object: '11',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.businesscard.shopping.long.exposure': {
        position: 'video.businesscard.shopping.long',
        action_object: '11',
        video_id: '',
        owner_id: '',
        type: '',
      },
      // adreport_type（100/200）；video_showtime；(点击时报)jump_type(h5/deeplink/wx)；ad_str& shop_info
    },
    // 点击上报
    user_action: {
      'cameratoo.bar.click': {
        position: 'cameratoo.bar',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'open.click': {
        position: 'open',
        action_object: '1',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.cameratoo.click': {
        position: 'video.cameratoo',
        action_object: '1',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.share.click': {
        position: 'video.share',
        action_object: '1',
        action_id: 1003001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.share.qq.click': {
        position: 'video.share.qq',
        action_object: '1',
        action_id: 1003002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.share.qzone.click': {
        position: 'video.share.qzone',
        action_object: '1',
        action_id: 1003003,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.share.weixin.click': {
        position: 'video.share.wxfriends',
        action_object: '1',
        action_id: 1003004,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.share.timeLine.click': {
        position: 'video.share.wxsquare',
        action_object: '1',
        action_id: 1003005,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.play': {
        position: 'video',
        action_object: '1',
        action_id: 1007001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.pause': {
        position: 'video',
        action_object: '1',
        action_id: 1007002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'hot.video.play.click': {
        position: 'hot.video.play',
        action_object: '1',
        action_id: 1007001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'more.video.click': {
        position: 'more.video',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.fold.click': {
        position: 'video.fold',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.like.click': {
        position: 'video.like',
        action_object: '1',
        action_id: 1001001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.comment.click': {
        position: 'video.comment',
        action_object: '1',
        action_id: 1002001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.headpic.click': {
        position: 'video.headpic',
        action_object: '2',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.headpic.focus.click': {
        position: 'video.headpic.focus',
        action_object: '2',
        action_id: 1004001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.topic.click': {
        position: 'video.topic',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.music.click': {
        position: 'video.music',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.location.click': {
        position: 'video.location',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'friendsfloat.open.click': {
        position: 'friendsfloat.open',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'friendsfloat.close.click': {
        position: 'friendsfloat.close',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'recommend.video.click': {
        position: 'recommend.video',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'recommend.open.click': {
        position: 'recommend.open',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'recommend.again.click': {
        position: 'recommend.again',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'jump.weishi.click': {
        position: 'jump.weishi',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'last.float.btn.click': {
        position: 'last.float.btn',
        action_object: '',
        action_id: 1000002,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'last.float.cancel.click': {
        position: 'last.float.cancel',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'collection.back.click': {
        position: 'collection.back',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'collection.fold.click': {
        position: 'collection.fold',
        action_object: '',
        action_id: 1000001,
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.businesscard.shopping.short.click': {
        position: 'video.businesscard.shopping.short',
        action_object: '11',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.businesscard.shopping.long.click': {
        position: 'video.businesscard.shopping.long',
        action_object: '11',
        video_id: '',
        owner_id: '',
        type: '',
      },
      'video.businesscard.shopping.long.close.click': {
        position: 'video.businesscard.shopping.long.close',
        action_object: '11',
        video_id: '',
        owner_id: '',
        type: '',
      },
    },
  },
};

export default config;
